import type { EgsCategoryMeta, EgsGuestCategoryDraft } from './types';

export function validateEgsCategory(category: EgsGuestCategoryDraft, meta: EgsCategoryMeta): string | null {
  if (!category.enabled) {
    return null;
  }

  const { label } = meta;

  if ((meta.ages === 'from' || meta.ages === 'both') && category.fromAge === '') {
    return `${label}: Aged From is required`;
  }

  if ((meta.ages === 'to' || meta.ages === 'both') && category.toAge === '') {
    return `${label}: Aged To is required`;
  }

  const fromAge = meta.ages === 'to' ? 0 : Number(category.fromAge);
  const toAge = meta.ages === 'from' ? 99 : Number(category.toAge);

  if (Number.isNaN(fromAge) || Number.isNaN(toAge)) {
    return `${label}: age values are invalid`;
  }

  if (fromAge > toAge) {
    return `${label}: Aged From must be ≤ Aged To`;
  }

  if (!category.inclusions.trim()) {
    return `${label}: Inclusions is required`;
  }

  if (!category.beddingType) {
    return `${label}: Bedding Type is required`;
  }

  if (category.beddingType === 'other' && !category.otherBeddingType.trim()) {
    return `${label}: Other Extra Bedding Type is required`;
  }

  if (category.rateType !== 'per_stay' && category.rateType !== 'daily_rate') {
    return `${label}: Rate Type is required (Per Stay or Daily Rate)`;
  }

  if (category.costPrice === '' || Number.isNaN(Number(category.costPrice))) {
    return `${label}: Cost is required`;
  }

  if (category.sellPriceAud === '' || Number.isNaN(Number(category.sellPriceAud))) {
    return `${label}: Sell (AUD) is required`;
  }

  if (category.applyMode === 'particular' && !category.applyRooms.length) {
    return `${label}: select at least one room type`;
  }

  return null;
}
